module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "140px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户选择"
    }
  }, [(_vm.formData.user.length > 0) ? _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showUserPicker = true
      }
    }
  }, [_vm._v(_vm._s(_vm.formData.user[0].name))]) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showUserPicker = true
      }
    }
  }, [_vm._v("请选择用户 "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申报等级",
      "prop": "typeName"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.typeName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "typeName", $$v)
      },
      expression: "formData.typeName"
    }
  }, _vm._l((_vm.typeColumns), function(item) {
    return _c('el-radio', {
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保存\n          ")])], 1)], 1), _vm._v(" "), _c('UserPicker', {
    attrs: {
      "show": _vm.showUserPicker,
      "limit": 1,
      "defaultValue": _vm.formData.user
    },
    on: {
      "onChange": _vm.onUserChange,
      "onClose": function($event) {
        _vm.showUserPicker = false
      },
      "onConfirm": _vm.onUserConfirm
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-240cadbf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailCommunityAdd.vue
// module id = 1382
// module chunks = 0